/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React, { Component } from 'react'

import * as Paint from './paint'

let id = 2
export class TRCCanvasComp extends Component {

    constructor(props) {
        super(props)

        this.onClick = this.onClick.bind(this)
    }

    componentDidMount() {
        let c = document.getElementById('test-canvas')
        //let renderer = new Paint.WebglRenderer()
        let r = new Paint.CanvasRenderer()

        this.canvas = new Paint.Canvas(c, r)
        this.canvas.providers.push(this)
        this.canvas.start()
        this.start = 0

        this.groupA = null
        this.groupB = null

        this.canvas.register('background', Background)
        this.canvas.register('ball', Ball)

        this.canvas.map = [
            { key: 'A1', draw: 'background', frame: Paint.rect(0, 0, 100, 100) }
        ]
    }

    onClick(e) {
        e.preventDefault()
        console.log('onClick', e)

        id += 1

        this.canvas.map.push({
            key: `A${id}`,
            draw: 'ball',
            frame: Paint.rect(e.clientX, e.clientY, 30, 30)
        })
    }

    componentWillUnmount() {
        this.canvas.stop()
    }

    update(size, time, delta) {
        for (let item of this.canvas.map) {
            if (item.draw === 'ball') {
                item.frame.y += 2.5
            }
            if (item.draw === 'background') {
                item.frame.w = size.w
                item.frame.h = size.h
            }
        }

        this.canvas.map = this.canvas.map.filter(item => item.frame.y < size.h)
        // return this.updateGrid(size, time, delta)
        // return this.updateCorners(size, time, delta)
        // return this.updateGroups(size, time, delta)
    }

    updateGroups(size, time, delta) {
        if (!this.groupA) {
            this.groupA = new LevelMap(Paint.rect(10, 10, size.w, size.h))
            this.canvas.add(this.groupA)
        }
        this.groupA.frame = Paint.rect(0, 0, size.w, size.h)

        /*
        if (!this.groupB) {
            this.groupB = new Paint.Rectangle(Paint.rect(10, 10, 400, 400))
            this.groupB.fill = '#00cc00'
            this.groupB.stroke = '#00ff00'
            this.groupB.lineWidth = 10
            this.canvas.add(this.groupB)
        }
        this.groupB.frame = Paint.rect(size.w-110, size.h-110, 100, 100)
        */
    }

    render() {
        return (
            <canvas
                id="test-canvas"
                onClick={this.onClick}
                style={{ background: '#222', width: '640px', height: '480px' }}
            />
        )
    }
}

class Ball extends Paint.Drawable {

    constructor(frame) {
        super(frame)

        this.bg = new Paint.Rectangle(Paint.rect(0, 0, frame.w, frame.h))
        this.bg.fill = '#AACC00'
        this.add(this.bg)

        this.layout()
    }


}

class Background extends Paint.Drawable {

    constructor(frame) {
        super(frame)

        this.sky = new Paint.Rectangle(Paint.rect(0, 0, frame.w, frame.h))
        this.sky.fill = '#0033CC'
        this.add(this.sky)

        this.land = new Paint.Rectangle(Paint.rect(0, frame.h/2, frame.w, frame.h/2))
        this.land.fill = '#654321'
        this.add(this.land)

        this.layout()
    }


}

class LevelMap extends Paint.Drawable {

    constructor(frame) {
        super(frame)
        this.cols = 16
        this.rows = 12

        for (let i = 0; i < this.cols * this.rows; i ++) {
            this.add(new Paint.Rectangle(Paint.rect(0, 0, frame.w/this.cols, frame.w/this.cols)))
        }

        this.layout()
    }

    layout() {
        let ec = '#333'
        let pc = '#900'
        let gc = '#090'
        let map = [
            [pc, pc, pc, pc,     pc, pc, pc, ec,     ec, pc, pc, pc,     pc, pc, pc, pc],
            [pc, ec, ec, ec,     ec, ec, pc, ec,     ec, pc, ec, ec,     ec, ec, ec, ec],
            [pc, ec, ec, ec,     ec, ec, pc, pc,     pc, pc, ec, ec,     ec, ec, ec, ec],
            [pc, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec],

            [pc, pc, pc, ec,     ec, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec],
            [ec, ec, pc, ec,     ec, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec],
            [ec, ec, pc, ec,     ec, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec],
            [pc, pc, pc, ec,     ec, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec],

            [pc, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec],
            [pc, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec],
            [pc, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec],
            [pc, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, ec,     ec, ec, ec, gc],
        ]

        let row = 0
        let col = 0
        let tw = this.frame.w / this.cols

        for (let i = 0; i < this.children.length; i++) {
            row = Math.floor(i / this.cols)
            col = i % this.cols

            let tile = this.children[i]
            tile.frame = Paint.rect(tw*col, tw*row, tw, tw)
            tile.fill = map[row][col]
        }
    }

}


